module.exports = __webpack_public_path__ + "img/img_18@2x.0d0d9290.png";